import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import AccessLogView from "../components/AccessLogView";
import StudentController from "../api/StudentController";
import { withData } from "../common/WithData";
import ErrorBoundary from "./ErrorBoundry";

class AccessLogs extends React.Component 
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);
        this.studentController = new StudentController();
    }

    render(): React.ReactNode 
    {
        const AccessLogsData = withData(
            AccessLogView,
            "Access Log",
            async () => await this.studentController.getAccessLogRecords()
        );

        return <Fragment>
            <ErrorBoundary>
                <h2>Log</h2>
                <AccessLogsData />
            </ErrorBoundary>
        </Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    student: state.student.activeStudent
});

export default connect(mapStateToProps)(AccessLogs);